import api from './api';

/**
 * Service for managing organization-level default documents (e.g., Infanion field validations).
 */
const orgDocumentService = {
  /**
   * Get all organization documents, optionally filtered by type.
   */
  getAll: async (documentType = null, activeOnly = false) => {
    const params = new URLSearchParams();
    if (documentType) params.append('document_type', documentType);
    if (activeOnly) params.append('active_only', 'true');
    const query = params.toString();
    const response = await api.get(`/org-documents${query ? `?${query}` : ''}`);
    return response.data;
  },

  /**
   * Get a single organization document by ID (includes full content).
   */
  getById: async (docId) => {
    const response = await api.get(`/org-documents/${docId}`);
    return response.data;
  },

  /**
   * Get the active organization document for a given type.
   * Returns { success, data, exists } — data is null if none exists.
   */
  getByType: async (documentType) => {
    const response = await api.get(`/org-documents/type/${documentType}`);
    return response.data;
  },

  /**
   * Upload a new organization document. Requires admin role.
   * @param {FormData} formData - Must include: document_type, title. Optional: description, version, file, content.
   */
  create: async (formData) => {
    const response = await api.post('/org-documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /**
   * Update an organization document. Requires admin role.
   */
  update: async (docId, formData) => {
    const response = await api.put(`/org-documents/${docId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /**
   * Delete an organization document. Requires admin role.
   */
  delete: async (docId) => {
    const response = await api.delete(`/org-documents/${docId}`);
    return response.data;
  },
};

export default orgDocumentService;
